import { Footer } from 'components/Organisms/Footers/Footer'
import { InvestorsSection } from 'components/Organisms/homeV3/InvestorSection'
import { ImmuneFiSection } from '../ImmuneFiSection'
import { JoinYoloSection } from '../JoinYoloSection'

export const Information = () => {
  return (
    <>
      <InvestorsSection />
      <ImmuneFiSection />
      <JoinYoloSection />
      <Footer position='relative' bgColor='transparent' />
    </>
  )
}
